import { ModelPreloader } from 'client/data/luckdragon/redux/model-preloader';
import { getModelState } from 'client/data/luckdragon/model';
import { CmsModel } from 'client/data/models/cms';
import { pageDefinition } from 'site-modules/shared/pages/page';
import { parseContent } from 'client/data/cms/content';
import { getMeta } from 'site-modules/shared/utils/seo-helper';
import { getBreadcrumbSchema } from 'client/seo/schemas/breadcrumbs';
import { getHomeBreadcrumb } from 'site-modules/shared/components/breadcrumbs/helper';
import { getPressLandingContentPath } from 'site-modules/editorial/utils/content-path';
import { PressModel, buildPressReleasesPath } from 'client/data/models/press';
import { PressLanding } from './press';
import { PressDecorator } from './press-decorator';

const PRESS_LANDING_CONTENT_PATH = getPressLandingContentPath();

export const pageOptions = {
  name: 'other_about_us_press_landing',
  category: 'other',
  decorator: PressDecorator,
  preload: store => {
    const preloader = new ModelPreloader(store);

    preloader.resolve(`content["${PRESS_LANDING_CONTENT_PATH}"]`, CmsModel);
    preloader.resolve(buildPressReleasesPath(), PressModel);

    return preloader.load();
  },
  seo: state => {
    const content = parseContent(getModelState(state).get(`content["${PRESS_LANDING_CONTENT_PATH}"]`, CmsModel));

    return {
      ...getMeta(content),
      jsonld: [getBreadcrumbSchema([getHomeBreadcrumb(), { title: 'Press', href: 'https://www.edmunds.com/press/' }])],
    };
  },
  component: PressLanding,
};

export default pageDefinition(pageOptions);
